import type { GeorgeFeatureConfig } from '@shared/george-config';
import type { Account } from '@shared/products-types';
import _ from '@luna/lodash';
import { getFeatureConfig } from '@luna/feature-config';

// @ts-expect-error no-implicit-any
const removeFalsyFields = (object) =>
    Object.entries(object).reduce(
        (acc, [key, value]) => (value ? { ...acc, [key]: value } : acc),
        {},
    );

// @ts-expect-error no-implicit-any
const customizer = (gAPIAccountField, webAPIAccountField, fieldName): any => {
    const { fieldsWithGAPIPriority = [] } =
        getFeatureConfig<GeorgeFeatureConfig, { fieldsWithGAPIPriority?: string[] }>(
            ({ products }) => products,
        ) ?? {};

    if (fieldName === 'flags' && Array.isArray(gAPIAccountField)) {
        return [...new Set([...gAPIAccountField, ...(webAPIAccountField ?? [])])];
    }

    if (fieldName === 'accountno') {
        return {
            ...gAPIAccountField,
            ...(webAPIAccountField ? removeFalsyFields(webAPIAccountField) : {}),
        };
    }

    if (fieldsWithGAPIPriority.includes(fieldName) && gAPIAccountField && webAPIAccountField) {
        return gAPIAccountField;
    }

    // undefined results in fallback to default merge implementation.
    return undefined;
};

const mergeGAPIAndWebAPIAccount = (gapiAccount: Account, webApiAccount: Account): Account =>
    _.merge({}, gapiAccount, webApiAccount, customizer);

export const mergeGAPIAndWebAPIAccounts = (
    gapiAccounts: Account[],
    webAPIAccountsById: { [id: string]: Account },
): any[] => {
    return gapiAccounts.map((GAPIAccount) =>
        mergeGAPIAndWebAPIAccount(GAPIAccount, webAPIAccountsById[GAPIAccount.id]),
    );
};
